import type { NodeTypes } from '@mv/core/model/heim/richText';
import { Html } from '@mv/ui-kit/primitives';
import type { ReactElement, ReactNode } from 'react';
import type { RichTextContext } from '../RichText';
import { collectLinks } from './collectLinks';
import { getPlainText } from './getPlainText';
import { linkActionProps } from './inlineA11y';

/**
 * Makes a block one screen-reader stop.
 *
 * The grouping goes on a view rather than on the text itself: `accessible` also makes a view take
 * keyboard focus, and only a view can opt out of that with `focusable`. Text cannot, so grouping
 * text directly put every paragraph into the keyboard tab order — in an order Android derives
 * from geometry rather than document order.
 */
export function withBlockA11y(
	block: ReactElement,
	nodes: NodeTypes[] | undefined,
	context: RichTextContext,
	label?: string,
): ReactNode {
	if (!context.screenReaderEnabled) return block;

	return (
		<Html.Div
			key={block.key}
			accessible
			focusable={false}
			accessibilityLabel={label ?? getPlainText(nodes, context.replacements)}
			{...linkActionProps(collectLinks(nodes, context))}
		>
			{block}
		</Html.Div>
	);
}
